import { render, staticRenderFns } from "./willregisterorder.vue?vue&type=template&id=3020df67&scoped=true&"
import script from "./willregisterorder.vue?vue&type=script&lang=js&"
export * from "./willregisterorder.vue?vue&type=script&lang=js&"
import style0 from "./willregisterorder.vue?vue&type=style&index=0&id=3020df67&scoped=true&lang=scss&"
import style1 from "./willregisterorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3020df67",
  null
  
)

export default component.exports